import {apsViewModels} from "../shared/dto/APS.ViewModels";
import * as angular from "angular";
import * as _ from "lodash";
import {apsEnums} from "../shared/dto/aps.enums";

export class DefectClassification {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

export function padLegacyId(legacyId: number) {
  return _.padStart(legacyId.toString(), 3, '0');
};

export class DefectType implements apsViewModels.DefectTypeSelection {
  id: string;
  legacyId: number;
  abbreviation: string;
  name: string;
  description: string;
  defectClassificationId: string;
  defectClassificationName: string;
  severity: apsEnums.Severity;
  wareClasses: apsViewModels.DefectTypeSelectionWareClass[];
  criticalThreshold: number;
  classification: DefectClassification;
  listName: string;
  defaultInspectionSampleSize: number;
  entireMachine: boolean;

  constructor(viewModel: apsViewModels.DefectTypeSelection,
              classifications: DefectClassification[]) {
    _.assign(this, viewModel || {});
    if (this.legacyId) {
      var paddedLegacyId = padLegacyId(this.legacyId);
      this.listName = this.name + ' (' + paddedLegacyId + ')';
    } else {
      this.listName = this.name;
    }
    if (this.defectClassificationId) {
      let classification = _.find(classifications,
        {id: this.defectClassificationId});
      if (!classification) {
        classification = new DefectClassification(
          this.defectClassificationId,
          this.defectClassificationName);
        classifications.push(classification);
      }

      this.classification = classification;
    }
  }
}

export default angular.module('aps.models', [])
  .service('defectTypeDetailsViewModelService', function() {
    return {
      apply: apply
    };

    function apply(viewModel) {
      let createFriendlyPercentageProperty = function(viewModel, basePropertyName) {
        let trimValueToFourDecimalSpaces = function(toConvert: Number) {
          return parseFloat(toConvert.toFixed(4));
        };

        Object.defineProperty(viewModel, basePropertyName + 'Friendly', {
          get: function() {
            let val = _.isUndefined(viewModel) ? undefined : viewModel[basePropertyName];
            return _.isUndefined(val) || _.isNull(val)  ? val : trimValueToFourDecimalSpaces(val * 100);
          },
          set: function(newValue) {
            viewModel[basePropertyName] = _.isUndefined(newValue)
              || _.isNull(newValue) ? newValue : trimValueToFourDecimalSpaces(newValue / 100);
          }
        });
      };

      createFriendlyPercentageProperty(viewModel, 'criticalThreshold');
      createFriendlyPercentageProperty(viewModel, 'requalificationThreshold');
    }
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/defectType.ts